import type { ModelUsage } from '../services/api'

export function formatUsd(value: number | null | undefined): string {
  if (value == null) return 'Unpriced'
  if (value > 0 && value < 0.0001) return `$${value.toFixed(6)}`
  return `$${value.toFixed(4)}`
}

export default function ModelUsageBreakdown({ usage }: { usage: ModelUsage[] }) {
  if (!usage.length) return <span className="text-base-content/40">No model usage</span>

  return (
    <details className="dropdown" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => event.stopPropagation()}>
      <summary className="cursor-pointer text-xs link link-hover">
        {usage.length} model{usage.length === 1 ? '' : 's'}
      </summary>
      <div className="dropdown-content z-30 mt-1 w-80 rounded-lg border border-base-300 bg-base-100 p-3 shadow-xl">
        <table className="table table-xs">
          <thead><tr><th>Model</th><th className="text-right">Tokens</th><th className="text-right">Spend</th></tr></thead>
          <tbody>{usage.map((item) => (
            <tr key={item.model}>
              <td className="max-w-36 truncate" title={item.model}>{item.model}</td>
              <td className="text-right tabular-nums" title={`${item.input_tokens.toLocaleString()} input · ${item.output_tokens.toLocaleString()} output`}>
                {item.total_tokens.toLocaleString()}
              </td>
              <td className="text-right tabular-nums">{formatUsd(item.spend_usd)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </details>
  )
}
